<script>
    import {secondToHour} from '../../utils.js';
    export let seconds = 0;
    export let additionalClasses = '';
    export let formatted = true;
</script>

<style>
    span {
        font-size: 0.9rem;
    }
</style>

<span class="{additionalClasses}">
    {#if formatted}
        {secondToHour(seconds)}
    {:else}
        {seconds}
    {/if}
</span>
